export interface IDetailsStepsStyles {
  topLabelStyle: { [x: string]: string }; // x should be valid css properties
  bottomLabelStyle: { [x: string]: string };
  circleStyles: { [x: string]: string };
}
